import unwrapList from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/unwrapList'
import type { MedflexServiceClass } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/types/medflex'

/** Разворачивает классы услуг и их `sublist` из SSR-контекста. */
export default function unwrapMedflexClasses(
  value: MedflexServiceClass[] | Record<string, MedflexServiceClass> | undefined,
): MedflexServiceClass[] {
  return unwrapList(value)
    .filter(item => Boolean(item?.name))
    .map(item => ({
      ...item,
      sublist: unwrapList(item.sublist),
    }))
}
